/**
 * Inline-SVG statt Icon-Font oder externem Sprite: keine zusaetzliche Anfrage,
 * keine Abhaengigkeit von einer fremden Quelle in der CSP, und die Farbe folgt
 * ueber `currentColor` automatisch dem Text.
 *
 * Alle Symbole sind rein dekorativ (`aria-hidden`). Bedeutung traegt immer der
 * begleitende Text -- ein Symbol allein wird nicht vorgelesen.
 */
type IconProps = { size?: number; className?: string };

function icon(path: React.ReactNode, viewBox = "0 0 24 24") {
  return function Icon({ size = 20, className }: IconProps): React.ReactElement {
    return (
      <svg
        width={size}
        height={size}
        viewBox={viewBox}
        fill="none"
        stroke="currentColor"
        strokeWidth={1.75}
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
        focusable="false"
        className={className}
      >
        {path}
      </svg>
    );
  };
}

export const ArrowRight = icon(
  <>
    <path d="M5 12h14" />
    <path d="m13 6 6 6-6 6" />
  </>,
);

export const Check = icon(<path d="m4 12 5 5L20 6" />);

export const Cross = icon(
  <>
    <path d="M6 6l12 12" />
    <path d="M18 6 6 18" />
  </>,
);

export const Warning = icon(
  <>
    <path d="M12 3 2 20h20L12 3Z" />
    <path d="M12 10v4" />
    <path d="M12 17.5v.01" />
  </>,
);

export const Info = icon(
  <>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 11v5" />
    <path d="M12 8v.01" />
  </>,
);

export const Upload = icon(
  <>
    <path d="M12 16V4" />
    <path d="m7 9 5-5 5 5" />
    <path d="M4 17v2a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-2" />
  </>,
);

export const Download = icon(
  <>
    <path d="M12 4v12" />
    <path d="m7 11 5 5 5-5" />
    <path d="M4 17v2a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-2" />
  </>,
);

export const Lock = icon(
  <>
    <rect x="4" y="10" width="16" height="10" rx="2" />
    <path d="M8 10V7a4 4 0 0 1 8 0v3" />
  </>,
);
